// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MyQzP","colBig":"styles_colBig__2OR_V","colSmall":"styles_colSmall__36hHc"};